import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "3.429",
      d: "M41.1 36a22.5 22.5 0 0 1-19-34.3 22.5 22.5 0 0 0 3.5 44.6 22.1 22.1 0 0 0 19-10.7 23 23 0 0 1-3.5.3Z"
    }, null, -1)
  ]));
}
const DarkMode = { render };
export {
  DarkMode as default,
  render
};
//# sourceMappingURL=DarkMode.svg.js.map
